export const pathToPost = (id: string, channelId: string): string =>
  `/${channelId}/post/${id}`
